<script>
export default {
  name: 'mrfOnayDetailList',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    truncatedSabitKiymet() {
      const val = this.item.sabit_Kiymet || '';
      return val.length > 10 ? val.substring(0, 10) + '...' : val;
    },
    isSabitKiymetLong() {
      const val = this.item.sabit_Kiymet || '';
      return val.length > 10;
    },
  },
};
</script>

<template>
  <tr>
    <td> {{ item.malzeme }} </td>
    <td> {{ item.miktar }} </td>
    <td> {{ item.birim }} </td>
    <td> {{ item.costCode }} </td>
    <td> {{ item.costName }} </td>
    <td> {{ item.teslim_Sekli }} </td>
    <td>
      <v-tooltip bottom v-if="isSabitKiymetLong">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">{{ truncatedSabitKiymet }}</span>
        </template>
        <span>{{ item.sabit_Kiymet }}</span>
      </v-tooltip>
      <span v-else>{{ item.sabit_Kiymet }}</span>
    </td>
  </tr>
</template>
